export const BOOL = "bool";
export const NUMBER = "number";
export const OBJECT = "object";
export const STRING = "string";

export const DEFAULTS = {
  [BOOL]: false,
  [NUMBER]: 0,
  [OBJECT]: {},
  [STRING]: "",
};

export const CONVERTERS = {
  // biome-ignore lint/suspicious/noDoubleEquals: preserve coercion for stored 0 and empty-string values.
  [BOOL]: (value) => (value === "false" ? false : !(value == false)),
  [NUMBER]: (value) => (Number.isNaN(Number(value)) ? DEFAULTS[NUMBER] : Number(value)),
  [OBJECT]: (value) => JSON.parse(value),
  [STRING]: (value) => value,
};

// LocalStorageService boolean flag for the TanStack Router shell.
export const SI_ROUTER = "siRouter";
